import { render } from "./BasicProduction.vue?vue&type=template&id=a6c31bf2"
import script from "./BasicProduction.vue?vue&type=script&lang=js"
export * from "./BasicProduction.vue?vue&type=script&lang=js"

import exportComponent from "/home/alejo/Development/AT/Apps/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__